import React from 'react';
import { GalleryArtworkGrid } from './GalleryArtworkGrid';


export const GalleryRotationContent = ({ rotation, artists, works }) => (
  <div className="pt-10">
    {rotation?.summary && (
      <p className="max-w-3xl text-base leading-7 text-[#5d6470]">{rotation.summary}</p>
    )}

    <section className="mt-12" data-testid="gallery-artists-section">
      <h3 className="font-gallery-heading text-2xl text-[#17243d]">Participating artists</h3>
      {artists.length ? (
        <div className="mt-6 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {artists.map((artist) => (
            <article key={artist.id} className="border-t-2 border-[#7c2434] pt-4" data-testid={`gallery-artist-${artist.id}`}>
              <h4 className="font-gallery-display text-2xl text-[#17243d]">{artist.display_name}</h4>
              {artist.short_bio && <p className="mt-2 text-sm leading-6 text-[#5d6470]">{artist.short_bio}</p>}
            </article>
          ))}
        </div>
      ) : (
        <p className="mt-4 text-sm text-[#5d6470]" data-testid="gallery-no-published-artists">No artist profiles are currently published.</p>
      )}
    </section>

    <section className="mt-14" data-testid="gallery-works-section">
      <h3 className="font-gallery-heading text-2xl text-[#17243d]">Published works</h3>
      <div className="mt-6">
        {works.length ? (
          <GalleryArtworkGrid works={works} artists={artists} />
        ) : (
          <p className="text-sm text-[#5d6470]" data-testid="gallery-no-published-works">No artwork is currently published.</p>
        )}
      </div>
    </section>
  </div>
);